import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getEvidenceList,
	addNewEvidence,
	updateEvidence,
	deleteEvidence,
	getEvidence,
	reviewEvidence
} from '../evidence/thunk';

export const initialState = {
	itemEvidenceList: [],
	itemEvidenceDetail: null,
	isEvidenceLoading: false,
	isEvidenceSuccess: false,

	evidenceList: [],
	evidenceListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	isReviewing: false,
	isReviewed: false,
	isReviewError: false,
	requireCloseModal: false,
};

const EvidenceSlice = createSlice({
	name: 'Evidences',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		updateEvidenceReviewed(state, action){
			console.log(action)
			state.itemEvidenceList = state.itemEvidenceList.map(evidence =>
				evidence._id === action.payload._id
					? { ...evidence, ...action.payload }
					: evidence
			);
		},
		cleanItemEvidencesList(state, action){
			state.itemEvidenceList = [];
		}
	},
	extraReducers: builder => {
		builder.addCase(getEvidence.fulfilled, (state, action) => {
			state.isEvidenceLoading = false;
			state.isEvidenceSuccess = true;
			state.itemEvidenceDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getEvidence.pending, state => {
			state.isEvidenceLoading = true;
			state.isEvidenceSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getEvidence.rejected, (state, action) => {
			state.isEvidenceLoading = false;
			state.isEvidenceSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getEvidenceList.pending, state => {
			state.isEvidenceSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getEvidenceList.fulfilled, (state, action) => {
			state.itemEvidenceList = action.payload;
			state.evidenceList = action.payload;
			state.isLoadingList = false;
			state.isEvidenceSuccess = true;

			let evidenceListSelect = [];
			action.payload.map(item =>
				evidenceListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.evidenceListSelect = evidenceListSelect;
		});
		builder.addCase(getEvidenceList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isEvidenceSuccess = true;
		});
		builder.addCase(addNewEvidence.fulfilled, (state, action) => {
			state.itemEvidenceList.push(action.payload);
			state.evidenceList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewEvidence.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewEvidence.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateEvidence.fulfilled, (state, action) => {
			state.itemEvidenceList = state.itemEvidenceList.map(evidence =>
				evidence.evidencename === action.payload.old_evidence
					? { ...evidence, ...action.payload.updated_evidence }
					: evidence
			);
			state.evidenceList = state.evidenceList.map(evidence =>
				evidence._id.toString() === action.payload._id.toString()
					? { ...evidence, ...action.payload }
					: evidence
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateEvidence.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateEvidence.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteEvidence.fulfilled, (state, action) => {
			state.itemEvidenceList = current(state.itemEvidenceList).filter(
				item => item._id !== action.payload._id
			);
			state.evidenceList = current(state.evidenceList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteEvidence.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteEvidence.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		builder.addCase(reviewEvidence.fulfilled, (state, action) => {
			state.itemEvidenceList = state.itemEvidenceList.map(evidence =>
				evidence._id === action.payload._id
					? { ...evidence, ...action.payload }
					: evidence
			);
			state.evidenceList.push(action.payload);
			state.isLoadingList = false;
			state.isReviewing = false;
			state.isReviewed = true;
			state.isReviewError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(reviewEvidence.pending, (state, action) => {
			state.isLoadingList = true;
			state.isReviewing = true;
			state.isReviewed = false;
			state.isReviewError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(reviewEvidence.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isReviewing = false;
			state.isReviewed = false;
			state.isReviewError = true;
			state.requireCloseModal = false;
		});
	},
});

export const {
	setRequireCloseModal,
	updateEvidenceReviewed,
	cleanItemEvidencesList
} = EvidenceSlice.actions;

export default EvidenceSlice.reducer;
